import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";

function RejectRequestModal() {
  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          <Grid item xs={12} md={12}>
            <div className="modalInput">
              <textarea
                className="textAriaSt"
                placeholder="Enter message of rejection"
              ></textarea>
            </div>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain">
              <Button className="modalMainBt rejectBtSt" onClick={addCommitee}>
                Reject
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
              <h4>Success !</h4>
              <p>
                Request Rejected <br />
                successfully
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default RejectRequestModal;
